@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.AssetLabel {
  @extend %font-family-primary;

  display: flex;
  align-items: center;
  column-gap: 8px;
  width: 100%;

  .AssetIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    // Override theme icon color
    > svg path {
      fill: $theme-filter-icon-color;
    }
  }

  .AssetText {
    display: flex;
    align-items: center;
    flex: 1;
  }
}
